import { render, staticRenderFns } from "./guestPC.vue?vue&type=template&id=b7a4e36e&scoped=true"
import script from "./guestPC.vue?vue&type=script&lang=js"
export * from "./guestPC.vue?vue&type=script&lang=js"
import style0 from "./guestPC.vue?vue&type=style&index=0&id=b7a4e36e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a4e36e",
  null
  
)

export default component.exports